import { getSetEntryRevisions } from './../../../../store/data/revisions/actions';
import { useEffect } from 'react';
import { OperationResult, HookOptions } from 'hooks/store/types';
import { ActionTypes, selectRevisions, Revision } from 'store/data/revisions';
import { useDispatch, useSelector } from 'hooks/utils';
import { useActivity } from 'hooks/store/utils/useActivity';

type Data = Revision[] | undefined;

export function useSetRevisions(options?: HookOptions): OperationResult<Data> {
	const dispatch = useDispatch();

	const { lazy = false } = options ?? {};

	const { subEntryId: entryId } = useSelector(state => state.data.entries.subEntries.selected);

	const data = useSelector(state => selectRevisions(state.data.revisions, { entryId }));
	const fetched = !!data;

	const [{ loading, error }, resetError] = useActivity(ActionTypes.GET_SET_ENTRY_REVISIONS);

	useEffect(() => {
		if (!error && !loading && !fetched && !lazy) {
			handler();
		}
	}, [error, loading, fetched, lazy]);

	function handler() {
		if (loading) return;
		if (error) resetError();

		dispatch(getSetEntryRevisions());
	}

	return [{ data, loading, error, fetched }, handler];
}
